import React from 'react'

import * as styles from './ImageWithText.module.scss'

import RedCircle from './red-circle.inline.svg'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  title?: string
  img?: JSX.Element | null
  redCircle?: boolean
}

const ImageWithText = (props: Props) => {
  const {text, title, img, redCircle = true} = props
  return (
    <div
      {...props}
      className={`d-flex flex-lg-column align-items-lg-center ${props.className}`}
    >
      <div className={styles.wrapper}>
        {img}
        {redCircle && <RedCircle className={styles.circle} />}
      </div>
      <div className="d-flex flex-column justify-content-center text-start text-lg-center">
        {title && <h3 className="fs-5 text-primary fw-bold">{title}</h3>}
        {text && <p className="mb-0">{text}</p>}
      </div>
    </div>
  )
}

export default ImageWithText
